export default __webpack_public_path__ + "static/media/22.5d3f4103.webp";